<template>
  <nav>
    <div class="nav-inner">
      <router-link to="/session" class="nav-logo">
        CAT <span>Session</span>
      </router-link>

      <ul class="nav-links">
        <li><router-link to="/session" exact>Home</router-link></li>
        <li><router-link to="/session/sandbox">Sandbox</router-link></li>
        <li><router-link to="/session/docs">Docs</router-link></li>
        <li><router-link to="/session/benchmarks">Benchmarks</router-link></li>
        <li><router-link to="/session/signin">Sign in</router-link></li>
      </ul>

      <router-link to="/session/signup" class="nav-cta">Get API key →</router-link>
    </div>
  </nav>
</template>

<style scoped>
nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(245, 244, 240, 0.92);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--border);
  z-index: 100;
}

.nav-inner {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
}

.nav-logo {
  font-family: var(--font-serif);
  font-size: 18px;
  font-weight: 700;
  color: var(--navy);
  text-decoration: none;
  letter-spacing: -0.01em;
}

.nav-logo span {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.1em;
  color: var(--muted);
  margin-left: 8px;
  vertical-align: middle;
}

.nav-links {
  display: flex;
  gap: 32px;
  list-style: none;
}

.nav-links a {
  color: var(--muted);
  text-decoration: none;
  font-size: 12px;
  letter-spacing: 0.05em;
  transition: color 0.2s;
  padding: 2px 0;
  border-bottom: 2px solid transparent;
}

.nav-links a:hover { color: var(--navy); }

.nav-links a.router-link-active,
.nav-links a.router-link-exact-active {
  color: var(--navy);
  border-bottom-color: var(--navy);
}

.nav-cta {
  background: var(--navy);
  color: white !important;
  padding: 6px 16px !important;
  border-radius: 2px;
  font-family: var(--font-mono);
  font-size: 12px;
  letter-spacing: 0.05em;
  text-decoration: none;
  transition: background 0.2s;
}

.nav-cta:hover { background: #2a4070 !important; }

@media (max-width: 720px) {
  .nav-links { display: none; }
}
</style>
